import util from '@bmp-vue/core/api/util'
const controller = 'Stefanini'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  Get () {
    return [
      { modelo: 0, prazoInicio: 1, prazoFim: 23, taxa: 1.95 },
      { modelo: 0, prazoInicio: 24, prazoFim: 35, taxa: 1.85 },
      { modelo: 0, prazoInicio: 36, prazoFim: 47, taxa: 1.75 },
      { modelo: 0, prazoInicio: 48, prazoFim: 60, taxa: 1.75 },
      { modelo: 1, prazoInicio: 1, prazoFim: 23, taxa: 2.36 },
      { modelo: 1, prazoInicio: 24, prazoFim: 35, taxa: 1.95 },
      { modelo: 1, prazoInicio: 36, prazoFim: 47, taxa: 1.82 },
      { modelo: 1, prazoInicio: 48, prazoFim: 60, taxa: 1.80 },
      { modelo: 2, prazoInicio: 1, prazoFim: 23, taxa: 2.77 },
      { modelo: 2, prazoInicio: 24, prazoFim: 35, taxa: 2.06 },
      { modelo: 2, prazoInicio: 36, prazoFim: 47, taxa: 1.89 },
      { modelo: 2, prazoInicio: 48, prazoFim: 60, taxa: 1.85 },
      { modelo: 3, prazoInicio: 1, prazoFim: 23, taxa: 3.18 },
      { modelo: 3, prazoInicio: 24, prazoFim: 35, taxa: 2.16 },
      { modelo: 3, prazoInicio: 36, prazoFim: 47, taxa: 1.95 },
      { modelo: 3, prazoInicio: 48, prazoFim: 60, taxa: 1.90 }
    ]
  },
  GetItem (modelo, prazo) {
    return ctrl.Get().find(item => item.modelo === modelo && item.prazoInicio <= prazo && item.prazoFim >= prazo)
  },
  TabelaComissao: [
    { text: 'Modelo 0', value: 0 },
    { text: 'Modelo 1', value: 1 },
    { text: 'Modelo 2', value: 2 },
    { text: 'Modelo 3', value: 3 },
    { text: 'Modelo Taxa', value: 4 },
  ],
  GetTaxa (th) {
    var taxa = 0
    const tx = ctrl.GetItem(th.model.ModeloComissao, th.model.Parcelas)
    if (tx) {
      taxa = tx.taxa
    }
    th.$set(th.model, 'PercJurosMensal', taxa)
  },
  ChangeVlrProdutoBem (th, value) {
    let vlrEntrada = 0
    if (value) {
      value = th.$api.UI.Parse.Decimal(value)
      vlrEntrada = parseFloat((value * th.$param.VlrMinEntrada).toFixed(2))
    }
    th.$set(th.model, 'VlrEntrada', vlrEntrada)
  },
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.PropostaDadosVeiculo.ZeroKM) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTAVEICULO_ZEROKM', ValorCampo: th.model.PropostaDadosVeiculo.ZeroKM }) }
    if ([null, undefined].indexOf(th.model.ModeloComissao) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_MODELOCOMISSAO', ValorCampo: th.model.ModeloComissao }) }
    if ([null, undefined].indexOf(th.model.ObservacaoVendedor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_OBSERVACAOVENDEDOR', ValorCampo: th.model.ObservacaoVendedor }) }

    if (campos.length > 0) { th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campos }) }
  },
  ImportaAssinante (th, request, importEmitente) {
    if (importEmitente) {
      th.$api.Multiplo.Post('InsertCCBDigitalAssinatura', request).then(function (response) {
        th.$api.UI.PostAction(response, 'Importação realizada com sucesso!')
      })
    }
  },
  CarregaDiasAcrescimo (th, value) {
    if (value && !ctrl.AllowedDates(th, value)) {
      let date = new Date(value)
      date = th.$api.UI.Date.AddDay(date, 1).toISOString().substr(0, 10)
      th.$set(th.model, 'DtPrimeiroVencto', date)
      ctrl.CarregaDiasAcrescimo(th, date)
    }
  },
  AllowedDates (th, value) {
    if (th && value) {
      return ![0, 6].includes(th.$api.UI.Parse.Date(value).getDay())
    } else {
      const date = new Date(`${th} 00:00:00`)
      const dayOfWeek = date.getDay()
      const isWeekend = [0, 6].includes(dayOfWeek)
      if (!isWeekend) { return date }
    }
  },
  async CarregaDados (th, documento) {
    const obj = await th.$api.Multiplo.CarregaDadosPessoa(documento)
    if (obj) {
      th.$set(th.model.Pessoa, 'TipoPessoa', documento.replace(/[^\d]/g, '').length === 11 ? th.$aux.TipoPessoaEnum.PF : th.$aux.TipoPessoaEnum.PJ);
      th.$set(th.model.Pessoa, 'DocumentoFederal', documento);
      th.$set(th.model.Pessoa, 'Nome', obj.Nome);
      if (th.model.Pessoa.TipoPessoa === th.$aux.TipoPessoaEnum.PF) {
        th.$set(th.model, 'DtNascimento', obj.PF.DtNasc);
        th.$set(th.model.Pessoa, 'EstadoCivil', obj.PF.EstadoCivil);
        th.$api.UTIL.Functions.SetAllButNull(th, th.model.Pessoa, 'PF', obj.PF)
      } else {
        th.$api.UTIL.Functions.SetAllButNull(th, th.model.Pessoa, 'PJ', obj.PJ)
      }
      if (obj.PessoaDadosContato) {
        th.$set(th.model.Pessoa.PessoaDadosContato, 'Email', obj.PessoaDadosContato.Email)
        th.$set(th.model.Pessoa.PessoaDadosContato, 'TelefoneCelular1', th.$api.UI.Format.Celular(obj.PessoaDadosContato.TelefoneCelular1))
        th.$set(th.model.Pessoa.PessoaDadosContato, 'TelefoneFixo1', obj.PessoaDadosContato.TelefoneFixo1 ? th.$api.UI.Format.Telefone(obj.PessoaDadosContato.TelefoneFixo1) : '')
      }
      if (obj.PessoaDadosEndereco) {
        th.$api.UTIL.Functions.SetAllButNull(th, th.model.Pessoa, 'PessoaEndereco', obj.PessoaDadosEndereco)
      }
    } else {
      th.$set(th.model, 'Pessoa', {
        ...th.model.Pessoa,
        DocumentoFederal: documento,
        PF: {},
        PJ: {},
        PessoaDadosContato: {},
        PessoaDadoFinanceiro: {},
        PessoaEndereco: {},
        PessoaQualificacao: {},
      })
    }
  }
})

export default ctrl
